import SignupContainer from "./SignupContainer";

const Signup = () => {
  return <div className="w-screen h-screen">
    <SignupContainer />
  </div>
}

export default Signup;